import { Modal } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { LastModifiedInfo } from "../documents/LastModifiedInfo.js";
import { LastModifiedInfoBoxFragment } from "../documents/LastModifiedInfo.generated.js";
import { UserAvatarFragment } from "../users/UserAvatar.generated.js";

interface Props {
  lastModified: LastModifiedInfoBoxFragment | null | undefined;
  createdBy: UserAvatarFragment;
  createdAt: string | Date | null | undefined;
  handleClose: () => void;
}

export const ProjectLastModifiedModal = ({
  lastModified,
  createdBy,
  createdAt,
  handleClose,
}: Props) => {
  const { t } = useTranslate("Global");

  return (
    <Modal
      title={t("Last modified", { ns: "Global" })}
      handleClose={handleClose}
      actionButtons={[
        {
          label: t("Close", { ns: "Global" }),
          handleClick: handleClose,
          buttonProps: { variant: "text" },
        },
      ]}
    >
      <LastModifiedInfo
        lastModified={lastModified}
        createdBy={createdBy}
        createdAt={createdAt}
      />
    </Modal>
  );
};
